import { TaskGenerationJobRunDao } from '@rock/db-admin';
import type { TaskGenerationJobRunId } from '@rock/types';
import { shallowEqual } from '@rock/util';
import { atomFamily } from 'jotai/utils';

const taskGenerationJobRunDao = new TaskGenerationJobRunDao();

export const taskGenerationJobRunsState = taskGenerationJobRunDao.taskGenerationJobRunsAtom();

export const taskGenerationJobRunState = atomFamily(
    (runId: TaskGenerationJobRunId | undefined) => taskGenerationJobRunDao.taskGenerationJobRunAtom(runId),
    shallowEqual,
);

export const taskGenerationJobRunTasksState = atomFamily(
    (runId: TaskGenerationJobRunId | undefined) => taskGenerationJobRunDao.tasksByJobRunIdAtom(runId),
    shallowEqual,
);
